export enum Column {
  PRIORITY,
  SCHEDULER_NAME,
  CATEGORIES,
  TIME_RANGE,
  ACTIONS,
}

export enum ColumnKeys {
  PRIORITY = 'priority',
  SCHEDULER_NAME = 'name',
  CATEGORIES = 'categories',
  TIME_RANGE = 'timeInterval',
  ACTIONS = 'actions',
}

export enum SubScheduleGridEvents {
  CLICK_ON_DELETE_ICON = 'clickOnDeleteIcon',
  CLICK_ON_EDIT_ICON = 'clickOnEditIcon',
  CLICK_ON_UP_ICON = 'clickOnUpIcon',
  CLICK_ON_DOWN_ICON = 'clickOnDownIcon',
  CHANGE_ON_ALL_WEBSITES = 'change',
}
